import { Price } from 'data-layer/src/entity/Price';

// todo: merge with data-layer/src/helpers/prices/findPrice.ts !

const findPrice = (
  prices: Array<Price> | null, 
  currencyId: string, 
  recommended: boolean = false, 
  vatRate: number | null = null,
  strictMode: boolean = false,
) => {
  if (!prices) {
    return 0;
  }

  const priceObject = prices.find(p => p.currencyId === currencyId);

  if (!priceObject) {
    if (strictMode) {
      return null;
    }
    return 0;
  }

  const defaultValue = strictMode === true ? null : 0;

  // ceny
  const priceWithout = priceObject && priceObject.priceWithout ? priceObject.priceWithout || defaultValue : defaultValue;
  const recommendedPriceWithout = priceObject && priceObject.recommendedPriceWithout
    ? priceObject.recommendedPriceWithout || defaultValue 
    : defaultValue;

  // cena z objektu Price
  let currPrice = priceWithout;
  if (recommended === true) {
    currPrice = recommendedPriceWithout;
  }

  if (currPrice === null) {
    if (strictMode) {
      return null;
    }
    return 0;
  }

  // výstup bude cena vč. DPH
  if (vatRate && vatRate > 0) {
    return (currPrice / 100) * (100 + vatRate);
  }

  return currPrice;
};

export default findPrice;


// WEBPACK FOOTER //
// ../helpers/src/prices/findPrice.ts